"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var FiscalisationActionTypeEnum;
(function (FiscalisationActionTypeEnum) {
    FiscalisationActionTypeEnum["Start"] = "start";
    FiscalisationActionTypeEnum["Archive"] = "archive";
    FiscalisationActionTypeEnum["Daily"] = "daily";
    FiscalisationActionTypeEnum["Monthly"] = "monthly";
    FiscalisationActionTypeEnum["Yearly"] = "yearly";
    FiscalisationActionTypeEnum["Zero"] = "zero";
})(FiscalisationActionTypeEnum = exports.FiscalisationActionTypeEnum || (exports.FiscalisationActionTypeEnum = {})); /**
* @export
* @enum {string}
*/
var FiscalisationActionStatusEnum;
(function (FiscalisationActionStatusEnum) {
    FiscalisationActionStatusEnum["InProgress"] = "in_progress";
    FiscalisationActionStatusEnum["Success"] = "success";
    FiscalisationActionStatusEnum["Error"] = "error";
})(FiscalisationActionStatusEnum = exports.FiscalisationActionStatusEnum || (exports.FiscalisationActionStatusEnum = {}));
function FiscalisationActionFromJSON(json) {
    return FiscalisationActionFromJSONTyped(json, false);
}
exports.FiscalisationActionFromJSON = FiscalisationActionFromJSON;
function FiscalisationActionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'posted_at': (json['posted_at'] === null ? null : new Date(json['posted_at'])),
        'integration': json['integration'],
        'integration_name': json['integration_name'],
        'processor_data': !runtime_1.exists(json, 'processor_data') ? undefined : json['processor_data'],
        'signatures': !runtime_1.exists(json, 'signatures') ? undefined : (json['signatures'] === null ? null : json['signatures'].map(_1.FiscalisationSignatureFromJSON)),
        'error': !runtime_1.exists(json, 'error') ? undefined : json['error'],
        'created_at': (new Date(json['created_at'])),
        'last_error_at': !runtime_1.exists(json, 'last_error_at') ? undefined : (json['last_error_at'] === null ? null : new Date(json['last_error_at'])),
    };
}
exports.FiscalisationActionFromJSONTyped = FiscalisationActionFromJSONTyped;
function FiscalisationActionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': value.type,
        'status': value.status,
        'posted_at': (value.posted_at === null ? null : value.posted_at.toISOString()),
        'integration': value.integration,
        'integration_name': value.integration_name,
        'processor_data': value.processor_data,
        'signatures': value.signatures === undefined ? undefined : (value.signatures === null ? null : value.signatures.map(_1.FiscalisationSignatureToJSON)),
        'error': value.error,
        'created_at': (value.created_at.toISOString()),
        'last_error_at': value.last_error_at === undefined ? undefined : (value.last_error_at === null ? null : value.last_error_at.toISOString()),
    };
}
exports.FiscalisationActionToJSON = FiscalisationActionToJSON;
